import { useLocation, useNavigationType } from 'react-router-dom'
import { useEffect } from 'react'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Action } from '@remix-run/router'

// Scroll to top of page when navigating to a new page using react-router.
const useScrollToTop = () => {
  const navigationType = useNavigationType()
  const location = useLocation()

  useEffect(() => {
    if (navigationType === Action.Push) {
      window.scrollTo(0, 0)
    }
  }, [location.pathname])
}

export default useScrollToTop
